import { Outlet, useParams } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'
import {
  GetModuleAvailabilitiesDocument,
  TrainingDetailPageDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { checkFeatures } from 'modules/core/hooks/useFeatures'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

const DetailRevamp = () => {
  const { id } = useParams()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data } = useQuery(TrainingDetailPageDocument, {
    variables: {
      trainingId: Number(id),
      resourceId: String(id),
      companyId,
    },
    fetchPolicy: 'cache-only',
  })

  const training = data?.trainings.training
  const trainingClasses = training?.trainingClassesConnection.nodes
  const canEdit = Boolean(training?._policies?.edit.can)
  const { has_dev_trainings: hasDevTrainings } = checkFeatures(
    ['dev_trainings'],
    data?.features.featuresConnection.nodes
  )

  const { data: featureData } = useQuery(GetModuleAvailabilitiesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      ids: [AvailableModules.lms],
      companyId,
    },
  })

  const moduleAvailabilities = featureData?.companies.moduleAvailabilities ?? []
  const hasLMSModule = isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.lms)

  const hasContentFF = hasLMSModule

  return (
    <Outlet
      context={{
        scores: data?.forms.scores,
        classes: trainingClasses,
        training,
        competencies: training?.competenciesConnection.nodes,
        canEdit,
        hasDevTrainings,
        hasContentFF,
      }}
    />
  )
}

export default DetailRevamp
